export const TELEGRAM_COLOR = '#24A1DE';
export const TWITTER_COLOR = '#1DA1F2';
export const YOUTUBE_COLOR = '#FF0000';
export const FACEBOOK_COLOR = '#316FF6';
export const INSTAGRAM_COLOR = '#3b5999';
export const LINKEDIN_COLOR = '#0A66C2';

export const OFFICIAL_WEBSITE_URL = 'https://dashenbanksc.com';
export const TELEGRAM_URL = ' https://t.me/DashenBankEthiopia ';
export const TWITTER_URL = ' https://twitter.com/BankDashen';
export const YOUTUBE_URL = 'https://www.youtube.com/channel/UCa17Hsba919G_8csRG4Gr3A';
export const FACEBOOK_URL = 'https://www.facebook.com/DashenBankOfficial';
export const INSTAGRAM_URL = 'https://www.instagram.com/dashenbankofficial/ ';
export const LINKEDIN_URL = 'https://www.linkedin.com/company/dashen-bank-official-page';

export const SOCIAL_MEDIA_FONT_SIZE = '24px';